export default "<lib-api-dummy-list [widget]=\"true\"></lib-api-dummy-list>"